var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20131",
    transform: "translate(-264 -112)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1125",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(264 112)",
    style: {
      fill: "#1bc47d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20130"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18600"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8835",
    d: "M97.847 102.366zm10.717-15.9v-.022a24.436 24.436 0 0 0-10.691-2.168A28.939 28.939 0 0 0 87.1 86.447v5.2a10.653 10.653 0 0 0 1.025 4.576l.012.027q.069.147.143.29a7.302 7.302 0 0 0 .33.588 10.653 10.653 0 0 0 .718 1.055l.018.023 6.163-5.918a.98.98 0 0 1 1.369.012l1.485 1.477 2.408-2.408-.07-.044-.094-.059a.372.372 0 0 1-.108-.115l-.01-.015a.468.468 0 0 1 .206-.831c.314-.129.641-.231.956-.33l.048-.015a86.975 86.975 0 0 1 2.114-.64.6.6 0 0 1 .471.131.471.471 0 0 1 .115.626l-.817 1.957c-.087.211-.175.422-.264.632a1.35 1.35 0 0 1-.151.27.57.57 0 0 1-.366.265.412.412 0 0 1-.049 0 .623.623 0 0 1-.375-.168.817.817 0 0 0-.311-.193l-3.01 3.009a.98.98 0 0 1-1.383 0l-1.5-1.49-5.493 5.275A10.717 10.717 0 0 0 92.593 101l.042.024a10.652 10.652 0 0 0 4.537 1.317l.674.021h.044l.6-.02a10.716 10.716 0 0 0 10.07-10.7v-4.94c.004-.078.008-.166.004-.232z",
    transform: "translate(190.118 47.133)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8836",
    d: "M92.821 16.677a5.008 5.008 0 0 0-.25.735 3.8 3.8 0 0 1-2.819 2.165.063.063 0 0 0-.017 0 19.725 19.725 0 0 0-5.606 1.865 6.718 6.718 0 0 0-3.238 4.972 11.817 11.817 0 0 0-.12 2.725 30.185 30.185 0 0 1 16.984-2.274 24.831 24.831 0 0 1 6.929 2.256 9.391 9.391 0 0 0 .066-2.707 7.882 7.882 0 0 0-.894-2.615 6.286 6.286 0 0 0-2.341-2.355 19.694 19.694 0 0 0-5.607-1.865.046.046 0 0 0-.015 0 4.409 4.409 0 0 1-1.756-.767 1.015 1.015 0 0 1-.383-1.089 5.784 5.784 0 0 1 2-2.842.873.873 0 0 0 .309-1.017.554.554 0 0 0-.785-.4 5.78 5.78 0 0 0-2.016 2.281c-.1.188-.285.554-.443.934",
    transform: "translate(195.216 103.959)",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogo);
export default __webpack_public_path__ + "static/media/profile-logo.c030dde71ea6ba1641e6bd5f141346a9.svg";
export { ForwardRef as ReactComponent };